<template>
  <v-container>
    <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
      <v-row>
        <v-col>
          <v-skeleton-loader
            type="table-heading, list-item-two-line, image, table-tfoot"
          ></v-skeleton-loader>
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-row>
    <div v-else>
      <v-row dense class="mt-9">
        <v-row dense>
          <v-col>
            <v-card
              elevation="1"
              style="border-radius: 10px; position: relative; overflow: visible"
            >
              <v-card-text>
                <v-row dense style="padding: 2vh">
                  <v-col cols="12" md="10">
                    <div class="d-flex align-start justify-start flex-column">
                      <span class="header">Minhas Aulas</span>
                      <span class="regular mt-4"
                        >Confira suas próximas aulas.</span
                      >
                    </div>
                  </v-col>
                  <v-col cols="12" md="2" class="image-col"> </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-row>
      <v-row dense style="margin-top: 5vh">
        <v-row style="background-color: #e7e7eb; border-radius: 30px">
          <v-col class="d-flex align-center justify-center"
            ><strong>Código</strong></v-col
          >
          <v-col class="d-flex align-center justify-center"
            ><strong>Nível</strong></v-col
          >

          <v-col class="d-flex align-center justify-center"
            ><strong>Horários</strong></v-col
          >
          <v-col class="d-flex align-center justify-center"
            ><strong>Alunos</strong></v-col
          >
          <v-col class="d-flex align-center justify-center"
            ><strong>Assunto</strong></v-col
          >
          <v-col class="d-flex align-center justify-center"
            ><strong>Ações</strong></v-col
          >
        </v-row>
      </v-row>
      <v-row
        dense
        style="margin-top: 5vh"
        v-for="(item, index) in mockAulas"
        :key="index"
      >
        <v-col class="d-flex align-center justify-center"
          ><strong>{{ item.cod }}</strong></v-col
        >
        <v-col class="d-flex align-center justify-center"
          ><strong>{{ item.level }}</strong></v-col
        >

        <v-col class="d-flex align-center justify-center"
          ><strong
            ><v-chip small>{{ item.hour }}</v-chip></strong
          ></v-col
        >
        <v-col class="d-flex align-center justify-center"
          ><strong>
            <v-chip-group column>
              <v-chip small v-for="(student, i) in item.students" :key="i">
                {{ student }}
              </v-chip>
            </v-chip-group>
          </strong></v-col
        >
        <v-col class="d-flex align-center justify-center"
          ><strong>{{ item.subject }}</strong></v-col
        >
        <v-col class="d-flex align-center justify-center"
          ><strong>
            <v-btn icon v-if="module === 'professor'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs">mdi-pencil</v-icon>
                </template>
                <span>Alterar aula</span>
              </v-tooltip>
            </v-btn>
            <v-btn icon v-else>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs">mdi-eye</v-icon>
                </template>
                <span>Ver aula</span>
              </v-tooltip>
            </v-btn>
          </strong></v-col
        >
      </v-row>
    </div>
  </v-container>
</template>
<script>
export default {
  name: "PartnerLeasonsForm",
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  mounted: {},
  data: () => {
    return {
      module: "professor",
      loading: true,
      mockAulas: [
        {
          cod: "2025-e1f3",
          level: "Essential 1",
          hour: "08:00",
          students: ["Lucas Moura", "Sophia Braga"],
          subject: "Present simple",
        },
      ],
    };
  },
  methods: {},
};
</script>
<style scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}
</style>
